import React from "react"
import { useRefinementList } from "react-instantsearch"
import "./NavSearch.scss"

const connectRefinementList = Component => {
  const RefinementList = props => {
    const data = useRefinementList(props)
    return <Component {...props} {...data} />
  }

  return RefinementList
}

const RefinementList = ({ items, attribute, refine }) => {
  if (items.length === 0) {
    return null
  }

  return (
    <div>
      <h3 className="luna-nav-search__filter-panel__title">Search in</h3>

      <ul className="luna-nav-search__filter-list">
        {items.map(item => {
          return (
            <li className="luna-nav-search__filter-list__item" key={item.label}>
              <button
                className={
                  item.isRefined
                    ? "luna-nav-search__filter luna-nav-search__filter-active"
                    : "luna-nav-search__filter"
                }
                onClick={event => {
                  event.preventDefault()
                  refine(item.value)
                }}
              >
                {item.label}
              </button>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

const CustomRefinementList = connectRefinementList(RefinementList)

export default CustomRefinementList
